import { JSX } from 'react';
import IcekingGif from '../../assets/images/gifs/iceking_jump.gif';
import './loading.css';

const Loading = (): JSX.Element => {
    return (
        <div className="loading-overlay">
            <div className="loading-content">
                <p>Loading...</p>
                <img src={IcekingGif} alt="Loading" />
            </div>
        </div>
    )
}

export default Loading;